<template>
    <div>
        <loading-block v-if="dataIsLoading"></loading-block>
        <section v-else>
            <info-message v-if="displayMessage" status="success">{{message}}</info-message>
            <div>
                <h1>Cours</h1>
                <uni-button @click.native="addCourse = true">Créer un cours</uni-button>
            </div>

            <div v-for="category in categories">
                <h2>{{category.name}}</h2>
                <div class="grid">
                    <rich-course-card @click.native="openEditModal(course)" v-for="course in category.courses"
                                      :course="course" :category="category"
                                      :administrator="true"></rich-course-card>
                </div>
            </div>
            <div>
                <!--                <admin-inline v-for="user in users" :user="user"-->
                <!--                              :family="families.find(el => el.id === user.family_id)"></admin-inline>-->
            </div>
            <!--        <user-inline v-for="user in users" :user="user"></user-inline>-->
        </section>
        <pop-from-bottom :open="addCourse"
                         title="Ajout d'un cours"
                         @close="addCourse = false"
        >
            <template slot="content">
                <form @submit.prevent="createNewCourse()">
                    <duo-input>
                        <uni-input-container label="Nom du cours" id="name">
                            <uni-input id="name" v-model="newCourse.name" rules="required"></uni-input>
                        </uni-input-container>
                        <uni-input-container label="Professeur" id="professor">
                            <select name="professor" id="professor" v-model="newCourse.professor" required>
                                <option selected value="Jockha LENG">Jockha LENG</option>
                                <option value="Nadia JUMONTIER">Nadian JUMONTIER</option>
                                <option value="Claire HINTERBERGER">Claire HINTERBERGER</option>
                                <option value="Mel La Cubaine">Mel La Cubaine</option>
                            </select>
                        </uni-input-container>
                    </duo-input>
                    <duo-input>

                        <uni-input-container label="Cagégorie" id="course_category">
                            <select name="day" id="course_category" v-model="newCourse.course_category_id" required>
                                <option v-for="category in categories" :value="category.id">{{category.name}}</option>

                            </select>
                        </uni-input-container>
                        <uni-input-container label="Jour" id="day">
                            <select name="day" id="day" v-model="newCourse.day" required>
                                <option selected value="Lundi">Lundi</option>
                                <option value="Mardi">Mardi</option>
                                <option value="Mercredi">Mercredi</option>
                                <option value="Jeudi">Jeudi</option>
                                <option value="Vendredi">Vendredi</option>
                            </select>
                        </uni-input-container>
                    </duo-input>
                    <duo-input>
                        <uni-input-container label="Durée">

                            <uni-input-radio label="1h"
                                             id="durationMin" style="margin-top:12px">
                                <input type="radio" v-model="newCourse.duration" id="durationMin"
                                       :value="1" placeholder="Nom" required>

                            </uni-input-radio>
                            <uni-input-radio label="1h30"
                                             id="durationMax" style="margin-top:12px">
                                <input type="radio" v-model="newCourse.duration" id="durationMax"
                                       :value="1.5" required>

                            </uni-input-radio>

                        </uni-input-container>
                        <uni-input-container label="Prix (€)" id="price">
                            <uni-input type="number" id="price" placeholder="75" v-model="newCourse.price" rules="required"></uni-input>
                        </uni-input-container>
                    </duo-input>
                    <duo-input>
                        <uni-input-container label="Début du cours" id="hour">
                            <select id="hour" v-model="newCourse.hour" required>
                                <option :value="hour.number" v-for="hour in hours">{{hour.value}}</option>
                            </select>
                        </uni-input-container>
                        <uni-input-container label="Âge" id="age">
                            <uni-input rules="required" id="age" placeholder="ex: de 6 à 10 ans"
                                       v-model="newCourse.age"></uni-input>
                        </uni-input-container>
                    </duo-input>
                    <uni-loading-button :is-disable="newCourseButton" text="Créer le cours"></uni-loading-button>
                </form>
            </template>
        </pop-from-bottom>
        <pop-from-bottom :open="editCourse"
                         title="Modifier un cours"
                         @close="editCourse = false"
        >
            <template slot="content">
            </template>
        </pop-from-bottom>
    </div>
</template>

<script>
    import LoadingBlock from "../../components/c-blocks/LoadingBlock";
    import UserInline from "../../components/b-patterns/userInline";
    import UniButton from "../../components/a-elements/UniButton";
    import PopFromBottom from "../../components/c-blocks/PopFromBottom";
    import UniInputContainer from "../../components/a-elements/UniInputContainer";
    import UniInput from "../../components/a-elements/UniInput";
    import InputBirthday from "../../components/a-elements/InputBirthday";
    import RichYesNoInput from "../../components/a-elements/RichYesNoInput";
    import UniInputRadio from "../../components/a-elements/UniInputRadio";
    import DuoInput from "../../components/b-patterns/DuoInput";
    import AdminInline from "../../components/b-patterns/adminInline";
    import RichCourseCard from "../../components/a-elements/RichCourseCard";
    import UniLoadingButton from "../../components/b-patterns/UniLoadingButton";
    import InfoMessage from "../../components/a-elements/InfoMessage";

    export default {
        name: "adminCourses",
        components: {
            InfoMessage,
            UniLoadingButton,
            RichCourseCard,
            AdminInline,
            DuoInput,
            UniInputRadio,
            RichYesNoInput,
            InputBirthday, UniInput, UniInputContainer, PopFromBottom, UniButton, UserInline, LoadingBlock
        },
        data() {
            return {
                users: [],
                families: [],
                dataIsLoading: false,
                addCourse: false,
                editCourse: false,
                hours: [],
                categories: [],
                currentCourse: {},
                displayMessage: false,
                message: '',
                newCourse: {
                    name: '',
                    day: 'Lundi',
                    duration: null,
                    price: null,
                    hour: 24,
                    age: '',
                    professor: '',
                    course_category_id: null
                },
                newCourseButton: false,
            }
        },
        methods: {
            openEditModal(course) {
                this.currentCourse = course
                this.editCourse = true
            },
            createNewCourse() {
                this.newCourseButton = true
                let obj = {
                    course: {
                        ...this.newCourse
                    }
                }

                this.$http.post('/courses', obj, this.$getHeaders())
                    .then(response => {
                        this.newCourseButton = false
                        this.addCourse = false
                        this.categories.find(el => el.id === response.data.course_category_id).courses.push(response.data)
                        this.dispMessage("Le cours a bien été créé")
                    })
                    .catch(error => {
                        if (this.$isSignatureExpired(error.response.data.message)) {
                            this.$store.dispatch('logout')
                            this.$router.push({name: 'Login', params: {q: 'expired'}})
                        }
                    })

            },
            dispMessage(message) {
                this.message = message
                this.displayMessage = true
                window.setTimeout(() => {
                    this.displayMessage = false
                }, 5000)
            }
        },
        async created() {
            // this.$adminGetDancers()
            //     .then(data => {
            //         this.users = data
            //         this.dataIsLoading = false
            //     })
            let arr = []
            for (let i = 24; i <= 44; i++) {
                let obj
                if (i % 2 === 1) {
                    // c'est impair
                    obj = {
                        number: i,
                        value: Math.floor(i / 2) + "h30"
                    }
                } else {
                    obj = {
                        number: i,
                        value: i / 2 + "h"
                    }
                }
                arr.push(obj)
            }
            this.hours = arr
            let response = await this.axios.get('/course_categories')

            this.categories = response.data


        }
    }
</script>

<style scoped lang="scss">

    section {
        > div:first-child {
            margin-bottom: 1rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }

    .grid {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 1rem;
        margin-bottom: 2rem;
    }


    @include screen-m {
        .grid {
            grid-template-columns: 1fr 1fr;

        }
    }

    select {
        outline: none;
        border: 1px solid var(--color-grey-light-1);
        height: 48px;
        font-size: 1rem;
        line-height: 1rem;
        border-radius: var(--radius-default);
        width: 100%;
        transition: var(--transition-quick);
        display: block;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
        background: none;
        color: var(--color-accent);
    }

</style>
